import React from "react";
import "./experience.css";

const Experience =()=> {
  const experiences = [
    {
      empresa: "ISM Computación",
      cargo: "Técnico Capacitado en Hardware/Software",
      fecha: "2019 - 2024",
      descripcion: "Desarrollo de páginas web con HTML, CSS, JavaScript, CMS WordPress, instalaciones de red local y reparación de equipos informáticos.",
    },
    {
      empresa: "Mercantil Banco C.A",
      cargo: "Teleoperador",
      fecha: "2018 - 2019",
      descripcion: "Gestión de bases de datos, atención al cliente y soporte tecnológico. ",
    },
  ];

  return (
    <section id="experience" className="experience">
      <h2>Experiencia</h2>
      <div className="experience-container">
        {experiences.map((exp, index) => (
          <div key={index} className="experience-card">
            <h3>{exp.empresa}</h3>
            <p className="cargo">{exp.cargo} | {exp.fecha}</p>
            <p>{exp.descripcion}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Experience;